import { Paper, Skeleton, Stack, Text, Title } from '@mantine/core'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { useParams } from 'react-router-dom'

import { useGetPersonAppointments } from '../../hooks/getPersonAppointments.hook'
import AppointmentCard from '../AppointmentCard/AppointmentCard'
import styles from './appointment-list.module.scss'

const AppointmentList = () => {
  const { personId = '' } = useParams<{ personId: string }>()
  const { appointments, isLoading, isSuccess } = useGetPersonAppointments(
    personId || '',
  )

  return (
    <Paper mb="xl" shadow="xs" p="lg" radius="md">
      <Title order={5} mb="xs">
        Appointments
      </Title>
      <Skeleton visible={isLoading}>
        {appointments.length > 0 && isSuccess ? (
          appointments.map((appointment) => (
            <AppointmentCard
              key={appointment.id}
              appointment={appointment}
              personId={personId}
            />
          ))
        ) : (
          <Stack className={styles.emptyState}>
            <Text>No appointments found</Text>
          </Stack>
        )}
      </Skeleton>
    </Paper>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  AppointmentList,
  'is_enable_view_appointments_widget',
)
